import _ from 'lodash'

import { generatePath } from '@stackhouse/dashboard-components/Dashboard'
import Toast from '@stackhouse/dashboard-components/Toast'

export const SAVE_STANDARD = 0
export const SAVE_AS = 1
export const SAVE_AS_COMPLETE = 2

const save = function ({ client, withLoader, data, endpoint }, callback) {
    if (data) {
        const [rawData] = data
        return withLoader(done => {
            return client.post(endpoint, rawData)
                .then(({ data }) => {
                    done()

                    setTimeout(Toast.toast({
                        type: 'success',
                        showCloseButton: false,
                        text: 'Successfully saved.'
                    }), 3000)

                    callback && callback(true, data)
                })
                .catch((error) => {
                    done()

                    const invalidFields = _.get(error, 'response.data.errorDetail.invalidFields')
                    if (invalidFields) this.dataRef.current.setError(invalidFields)

                    callback && callback(false, error)
                })
        })
    }
}

export const EditDetailAction = () => ({
    id: 'edit',
    title: 'Edit',
    icon: 'mode_edit',
    container: 'navbar.left',
    onClick: function () {
        return this.props.setEditable && this.props.setEditable(true)
    }
})

const SaveAndCloseDetailAction = ({ endpoint, container }) => ({
    id: 'saveAndClose',
    title: 'Save and close',
    icon: 'save',
    container: container,
    onClick: function () {
        const { config } = this
        const { client, withLoader, location: { state: { onSave } = {} } } = this.props
        const data = this.dataRef.current.validateAndGetValue()

        return save.call(this,
            {
                data,
                client,
                withLoader,
                endpoint: `${generatePath(endpoint, config)}?saveMethod=0`
            },
            success => {
                if (success) {
                    onSave && onSave()
                    success && this.props.history.goBack()
                }
            }
        )
    }
})

export const SaveAndCloseDetailNavbarLeftAction = ({ endpoint }) => {
    return SaveAndCloseDetailAction({ endpoint, container: 'navbar.left' })
}

export const SaveAndCloseDetailNavbarDropdownAction = ({ endpoint }) => {
    return SaveAndCloseDetailAction({ endpoint, container: 'navbar.dropdown' })
}

const SaveDetailAction = ({ endpoint, container }) => ({
    id: 'save',
    title: 'Save',
    icon: 'save',
    container: container,
    onClick: function () {
        const { config, recordParamKey, resourceId } = this
        const { client, withLoader, history,
            location: { state, state: { onSave } = {} },
            match: { path, params } } = this.props

        const data = this.dataRef.current.validateAndGetValue()

        return save.call(this,
            {
                data,
                client,
                withLoader,
                endpoint: `${generatePath(endpoint, config)}?saveMethod=0`
            },
            (success, saveData) => {
                if (success) {
                    onSave && onSave()

                    if (resourceId == 0) {
                        const newResourceId = saveData.recordId;

                        history.replace({
                            state: {...state, data: null},
                            pathname: generatePath(path, { ...params, [recordParamKey]: newResourceId })
                        })
                    }
                    else {
                        this.setData(saveData.recordData)
                    }
                }
            }
        )
    }
})

export const SaveDetailNavbarLeftAction = ({ endpoint }) => {
    return SaveDetailAction({ endpoint, container: 'navbar.left' })
}

export const SaveDetailNavbarDropdownAction = ({ endpoint }) => {
    return SaveDetailAction({ endpoint, container: 'navbar.dropdown' })
}

const SaveAsDetailAction = ({ endpoint, container }) => ({
    id: 'saveAs',
    title: 'Save as',
    icon: 'save',
    container: container,
    onClick: function () {
        const { config, recordParamKey } = this
        const { client, withLoader, history,
            location: { state, state: { onSave } = {} },
            match: { path, params } } = this.props

        const data = this.dataRef.current.validateAndGetValue()

        return save.call(this,
            {
                data,
                client,
                withLoader,
                endpoint: `${generatePath(endpoint, config)}?saveMethod=1`
            },
            (success, saveData) => {
                if (success) {
                    onSave && onSave()

                    const newResourceId = saveData.recordId;

                    history.replace({
                        state: {...state, data: null},
                        pathname: generatePath(path, { ...params, [recordParamKey]: newResourceId })
                    })
                }
            }
        )
    }
})

export const SaveAsDetailNavbarLeftAction = ({ endpoint }) => {
    return SaveAsDetailAction({ endpoint, container: 'navbar.left' })
}

export const SaveAsDetailNavbarDropdownAction = ({ endpoint }) => {
    return SaveAsDetailAction({ endpoint, container: 'navbar.dropdown' })
}

const SaveAsCompleteDetailAction = ({ endpoint, container }) => ({
    id: 'saveAsComplete',
    title: 'Save as complete',
    icon: 'save',
    container: container,
    onClick: function () {
        const { config, recordParamKey } = this
        const { client, withLoader, history,
            location: { state, state: { onSave } = {} },
            match: { path, params } } = this.props

        const data = this.dataRef.current.validateAndGetValue()

        return save.call(this,
            {
                data,
                client,
                withLoader,
                endpoint: `${generatePath(endpoint, config)}?saveMethod=2`
            },
            (success, saveData) => {
                if (success) {
                    onSave && onSave()

                    const newResourceId = saveData.recordId;

                    history.replace({
                        state: {...state, data: null},
                        pathname: generatePath(path, { ...params, [recordParamKey]: newResourceId })
                    })
                }
            }
        )
    }
})

export const SaveAsCompleteDetailNavbarLeftAction = ({ endpoint }) => {
    return SaveAsCompleteDetailAction({ endpoint, container: 'navbar.left' })
}

export const SaveAsCompleteDetailNavbarDropdownAction = ({ endpoint }) => {
    return SaveAsCompleteDetailAction({ endpoint, container: 'navbar.dropdown' })
}

const ShareDetailAction = ({ container }) => ({
    id: 'share',
    title: 'Share',
    icon: 'share',
    container: container,
    onClick: function () {
        // const link = document.createElement('a')
        // link.href = 'mailto:?subject=&body=' + encodeURIComponent('<' + window.location.href + '>')
        // link.click()

        const url = 'mailto:?body=' + encodeURIComponent('<' + window.location.href + '>')
        let iframe = document.createElement('iframe');

        iframe.style.display = 'none';
        iframe.src = url;

        document.documentElement.appendChild(iframe);

        window.setTimeout(function () {
            document.documentElement.removeChild(iframe)
            iframe = null
        }, 50)
    }
})

export const ShareDetailNavbarLeftAction = () => {
    return ShareDetailAction({ container: 'navbar.left' })
}

export const ShareDetailNavbarDropdownAction = () => {
    return ShareDetailAction({ container: 'navbar.dropdown' })
}

export const DefaultFirstLevelDetailActions = ({ endpoint }) => [
    EditDetailAction(),
    SaveDetailNavbarLeftAction({ endpoint }),
    SaveAndCloseDetailNavbarDropdownAction({ endpoint }),
    SaveAsDetailNavbarDropdownAction({ endpoint }),
    SaveAsCompleteDetailNavbarDropdownAction({ endpoint }),
    ShareDetailNavbarDropdownAction()
]

export const DefaultFirstLevelDetailActionsWithoutEdit = ({ endpoint }) => [
    SaveDetailNavbarLeftAction({ endpoint }),
    SaveAndCloseDetailNavbarDropdownAction({ endpoint }),
    SaveAsDetailNavbarDropdownAction({ endpoint }),
    SaveAsCompleteDetailNavbarDropdownAction({ endpoint }),
    ShareDetailNavbarDropdownAction()
]

export const DefaultDetailActionsWithoutEdit = ({ endpoint }) => [
    SaveAndCloseDetailNavbarLeftAction({ endpoint }),
    SaveDetailNavbarDropdownAction({ endpoint }),
    SaveAsDetailNavbarDropdownAction({ endpoint }),
    SaveAsCompleteDetailNavbarDropdownAction({ endpoint }),
    ShareDetailNavbarDropdownAction()
]

const DefaultDetailActions = ({ endpoint }) => [
    EditDetailAction(),
    SaveAndCloseDetailNavbarLeftAction({ endpoint }),
    SaveDetailNavbarDropdownAction({ endpoint }),
    SaveAsDetailNavbarDropdownAction({ endpoint }),
    SaveAsCompleteDetailNavbarDropdownAction({ endpoint }),
    ShareDetailNavbarDropdownAction()
]

export default DefaultDetailActions
